var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _g3, _g4, _path7, _path8, _path9, _path10, _path11, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaby9Months(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 150,
    viewBox: "0 0 242 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M120.892 149.205C187.659 149.205 241.784 143.494 241.784 136.448C241.784 129.403 187.659 123.691 120.892 123.691C54.1252 123.691 0 129.403 0 136.448C0 143.494 54.1252 149.205 120.892 149.205Z",
    fill: "#FFDEA0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M220.966 110.494C219.93 111.238 218.863 111.929 217.806 112.641C217.462 112.873 217.085 113.082 216.75 113.316C216.647 113.388 215.713 114.302 215.77 114.307C216.205 114.341 216.654 114.379 217.041 114.58C217.428 114.782 217.741 115.191 217.691 115.625C217.615 116.281 216.842 116.576 216.195 116.705C208.726 118.19 200.813 117.611 194.143 113.633C188.786 110.438 183.663 106.863 178.663 103.17C173.465 99.3297 166.165 93.1277 167.183 85.7987C167.814 81.2517 172.278 77.8266 176.861 77.5556C180.142 77.3616 183.356 78.5616 185.991 80.4646C187.642 81.6566 189.135 83.5597 189.751 85.5227C189.974 86.2337 189.962 86.9856 190.217 87.6886C190.586 88.7066 191.294 89.6566 191.893 90.5506C194.465 94.3876 197.713 97.7676 201.427 100.512C203.536 102.07 205.797 103.425 208.171 104.54C208.972 104.917 209.733 105.402 210.587 105.656C211.612 105.961 212.191 105.755 212.989 105.109C214.271 104.073 215.552 103.037 216.834 102.001C217.47 101.487 218.093 100.949 218.745 100.455C219.144 100.153 219.959 99.9866 219.854 100.797C219.829 100.99 219.735 101.167 219.636 101.335C219.281 101.935 218.838 102.483 218.325 102.957C218.966 102.453 219.615 101.944 220.354 101.601C221.112 101.25 223.206 100.723 223.162 102.214C223.151 102.576 222.87 102.867 222.596 103.104C221.991 103.627 221.297 104.129 220.606 104.527C221.166 104.204 223.205 103.254 223.787 103.86C224.396 104.494 223.103 105.728 222.641 106.022C221.897 106.496 221.212 107.084 220.429 107.522C221.228 107.075 222.08 106.802 222.912 106.435C223.51 106.171 224.114 106.306 224.108 107.139C224.106 107.476 223.953 107.798 223.745 108.063C223.286 108.644 222.768 109.177 222.173 109.616C221.776 109.908 221.374 110.201 220.966 110.494Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M166.317 80.9857C161.717 92.9917 168.941 102.713 168.941 102.713C168.941 102.713 179.615 104.474 193.209 89.5337C193.209 89.5337 178.636 65.8357 166.317 80.9857Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.5,
    d: "M166.317 80.9857C161.717 92.9917 168.941 102.713 168.941 102.713C168.941 102.713 179.615 104.474 193.209 89.5337C193.209 89.5337 178.636 65.8357 166.317 80.9857Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M193.366 88.168C187.871 95.456 177.737 102 168.111 102.03",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.5,
    d: "M210.466 106.956C209.108 107.873 207.96 109.098 207.133 110.512",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M83.8571 112.313C82.9741 110.978 82.1241 109.025 80.9621 107.934C79.7091 106.758 79.1141 107.392 77.3651 107.689C74.4121 108.19 71.3451 108.028 68.4661 107.196C66.4201 106.605 64.2861 105.493 63.5591 103.491C63.0641 102.128 63.3351 100.573 64.0121 99.291C64.6891 98.009 65.7351 96.9609 66.8331 96.0139C73.8251 89.9809 84.7711 85.7849 92.7561 92.1319C95.1441 94.0299 97.0071 96.3549 98.7881 98.6759C94.9571 103.443 88.7791 108.406 83.8571 112.313Z",
    fill: "#FF766F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M98.6191 98.6699C93.9531 103.521 88.8981 107.997 83.5181 112.042",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M130.35 86.9197C124.347 83.2517 115.385 83.0017 112.167 90.4387C110.955 93.2387 110.921 95.6607 109.062 98.2727C106.72 101.562 104.161 104.597 102.071 108.08C99.7761 111.904 95.8501 117.609 95.4631 122.136C95.1471 125.843 97.8641 129.107 100.753 131.451C107.606 137.012 116.503 139.848 125.296 139.684C133.884 139.524 139.915 137.374 143.753 129.428C145.423 125.97 144.987 122.391 144.963 118.659C144.935 114.334 144.51 110.001 143.415 105.809C141.43 98.2167 137.046 91.0107 130.35 86.9197Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.5,
    d: "M138.225 130.808C134.476 130.461 130.607 132.396 128.635 135.604",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M159.371 66.6834C157.094 66.8304 156.05 68.3924 154.795 70.1494C153.811 71.5274 152.692 73.0224 150.738 74.0364C145.272 76.8734 138.04 76.0794 132.37 74.3814C124.492 72.0224 117.125 67.7664 108.96 66.7814C95.0841 65.1064 80.6831 74.4874 76.6061 87.8564C72.5301 101.225 79.2471 117.045 91.6971 123.397C98.5321 126.884 106.424 127.629 114.097 127.701C132.71 127.875 152.613 127.188 168.609 116.393C174.855 112.178 180.183 106.42 183.593 99.6774C184.577 97.7314 185.888 94.6064 186.902 91.2364C173.46 89.9244 161.954 82.0964 159.371 66.6834Z",
    fill: "#2F80ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.5,
    d: "M109.964 115.161C100.676 111.181 91.3882 105.873 83.4272 97.9119C81.0372 94.7249 78.1762 92.0159 76.2652 89.2119C73.0182 102.28 79.6642 117.258 91.6972 123.398C98.5322 126.885 106.424 127.63 114.097 127.702C132.71 127.876 152.613 127.189 168.609 116.394C174.855 112.179 180.182 106.421 183.593 99.6779C184.577 97.7319 185.889 94.6069 186.902 91.2369C186.012 91.1499 185.132 91.0299 184.261 90.8859C171.016 115.486 135.816 125.736 109.964 115.161Z",
    fill: "#1D1D1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M187.309 77.5745C185.943 75.4285 183.363 74.4525 180.961 73.6125C174.951 71.5115 168.941 69.4115 162.931 67.3105C161.461 66.7965 160.314 66.6215 159.371 66.6825C161.954 82.0955 173.46 89.9235 186.903 91.2355C188.415 86.2105 189.257 80.6355 187.309 77.5745Z",
    fill: "#876855"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.5,
    d: "M187.309 77.5745C185.943 75.4285 183.363 74.4525 180.961 73.6125C174.951 71.5115 168.941 69.4115 162.931 67.3105C161.461 66.7965 160.314 66.6215 159.371 66.6825C161.954 82.0955 173.46 89.9235 186.903 91.2355C188.415 86.2105 189.257 80.6355 187.309 77.5745Z",
    fill: "#1D1D1B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M162.048 77.2236C167.764 85.1416 176.187 90.0086 186.717 91.9456",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M57.9001 137.148C61.0191 138.124 64.1431 138.901 67.2371 139.293C75.6701 140.362 83.344 142.981 90.799 137.06C94.192 134.365 95.713 129.552 98.048 125.989C100.798 121.794 103.294 117.348 104.521 112.446C106.223 105.653 105.019 97.6679 99.739 93.0669C96.378 90.1369 89.9041 88.3229 85.5731 90.1419C80.9971 92.0629 77.623 98.8299 75.876 103.119C73.805 108.202 72.7131 113.619 71.632 119C71.827 118.029 54.847 120.049 53.522 120.156C48.756 120.542 43.5351 119.197 39.2191 122.146C37.4931 123.325 34.535 126.581 36.389 128.699C37.132 129.548 38.25 129.95 39.317 130.318C45.305 132.388 51.5931 135.174 57.9001 137.148Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M48.2561 136.736C46.9161 135.862 45.3591 134.407 43.8601 133.867C42.2431 133.285 41.9491 134.103 40.4621 135.07C37.9501 136.702 35.0711 137.772 32.0991 138.152C29.9871 138.422 27.5861 138.249 26.1251 136.701C25.1291 135.647 24.7611 134.112 24.8721 132.667C24.9841 131.221 25.5281 129.844 26.1591 128.539C30.1801 120.225 38.5591 112.028 48.4081 114.681C51.3531 115.474 53.9861 116.869 56.5421 118.292C54.9201 124.187 51.2221 131.195 48.2561 136.736Z",
    fill: "#FF766F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M56.3861 118.352C54.0311 124.657 51.1691 130.773 47.8381 136.621",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M80.9841 92.5492C86.1101 88.2342 94.3641 88.9192 99.4421 93.2902C104.52 97.6612 106.522 104.933 105.529 111.559",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    opacity: 0.5,
    d: "M72.855 118.933C75.139 118.482 77.546 118.676 79.729 119.486",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    opacity: 0.5,
    d: "M88.9962 133.723C87.8752 133.07 86.4592 133.321 85.2202 133.705C82.8262 134.448 80.5672 135.625 78.5852 137.16",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M177.193 141.718C171.538 142.008 165.4 141.82 160.437 138.893C157.016 136.875 154.702 133.411 152.932 129.855C150.154 124.271 147.777 118.493 145.568 112.683C143.272 106.642 140.485 97.4785 145.304 91.8635C148.294 88.3795 153.901 87.9114 157.902 90.1624C160.767 91.7734 162.822 94.5214 164.01 97.5464C165.205 100.587 164.523 103.072 164.221 106.142C164.107 107.297 164.607 107.806 165.088 108.791C165.747 110.14 166.134 111.68 166.593 113.106C167.651 116.389 168.592 119.709 169.414 123.058C170.054 125.666 170.322 128.358 170.969 130.951C171.606 133.501 173.476 132.78 175.675 133.048C176.845 133.191 177.948 133.324 179.108 133.394C179.937 133.444 180.89 133.591 181.699 133.791C182.265 133.931 182.817 134.185 183.225 134.602C183.398 134.779 183.546 134.988 183.613 135.227C183.68 135.466 183.659 135.736 183.518 135.941C183.313 136.24 182.919 136.333 182.56 136.384C181.768 136.496 180.913 136.543 180.117 136.505C181.074 136.551 182.018 136.836 182.84 137.327C183.121 137.495 183.424 137.786 183.315 138.094C183.234 138.325 182.963 138.421 182.724 138.475C181.777 138.691 180.791 138.732 179.829 138.597C180.094 138.634 180.544 138.883 180.806 139.003C181.12 139.146 181.534 139.328 181.713 139.637C181.882 139.929 181.835 140.314 181.651 140.596C181.467 140.878 181.164 141.067 180.846 141.177C180.146 141.418 179.422 141.586 178.683 141.633C178.192 141.663 177.695 141.692 177.193 141.718Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M147.234 87.3671C138.334 96.6461 141.218 108.409 141.218 108.409C141.218 108.409 150.371 114.176 168.699 105.685C168.699 105.685 164.468 78.1871 147.234 87.3671Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    opacity: 0.5,
    d: "M147.234 87.3671C138.334 96.6461 141.218 108.409 141.218 108.409C141.218 108.409 150.371 114.176 168.699 105.685C168.699 105.685 164.468 78.1871 147.234 87.3671Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M169.373 104.485C161.479 109.068 149.601 111.165 140.717 107.456",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    opacity: 0.5,
    d: "M150.741 119.333C152.627 120.182 153.623 122.61 152.876 124.539",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    opacity: 0.5,
    d: "M170.662 133.038C169.283 133.767 167.905 134.497 166.526 135.226",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    opacity: 0.8,
    d: "M200.779 6.19922C205.255 8.72222 208.349 13.5462 208.777 18.6672C209.204 23.7872 206.952 29.0572 202.956 32.2882",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M207.552 43.8902C207.419 47.6452 210.655 50.8812 211.399 54.5772C213.529 65.1602 206.756 76.3322 198.197 82.1262C191.433 86.7042 182.939 87.2242 175.027 86.7372C170.466 86.4572 165.867 85.4452 161.946 83.0982C156.044 79.5652 153.178 73.6602 149.288 68.3202C144.422 61.6402 140.435 53.6762 140.084 45.2952C139.882 40.4902 140.745 35.6692 142.623 31.2412C147.728 19.2052 159.556 11.1432 172.407 9.7032C176.604 9.2332 180.872 9.3462 185.04 10.0262C191.888 11.1432 198.102 15.1012 202.214 20.6612C207.131 27.3092 208.219 35.5402 207.569 43.6072C207.56 43.7022 207.555 43.7962 207.552 43.8902Z",
    fill: "#876855"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M141.578 60.8614C139.466 62.1554 139.028 65.1944 139.938 67.4984C140.848 69.8024 142.757 71.5394 144.604 73.1894C145.313 73.8224 146.043 74.4694 146.933 74.8034C148.16 75.2644 149.557 75.0684 150.762 74.5514C151.967 74.0344 153.017 73.2214 154.053 72.4174C154.266 72.2524 154.488 72.0754 154.587 71.8244C155.205 70.2614 152.724 64.8174 151.509 63.4874C149.45 61.2344 144.417 59.1224 141.578 60.8614Z",
    fill: "#876855"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    opacity: 0.3,
    d: "M204.314 51.7212C202.859 51.5562 201.324 51.9672 200.161 52.8732C197.605 54.8642 196.956 58.5812 199.068 61.0382C199.869 61.9712 200.901 62.7832 202.115 62.9812C202.699 63.0762 203.297 63.0242 203.882 62.9382C204.642 62.8262 205.4 62.6542 206.099 62.3332C209.829 60.6162 209.815 54.4652 206.357 52.3992C205.731 52.0252 205.032 51.8032 204.314 51.7212Z",
    fill: "#1D1D1B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    opacity: 0.3,
    d: "M166.412 57.8424C164.805 57.6594 163.109 58.1144 161.826 59.1144C159.003 61.3134 158.286 65.4184 160.619 68.1324C161.504 69.1624 162.643 70.0604 163.984 70.2784C164.629 70.3834 165.289 70.3264 165.935 70.2304C166.775 70.1064 167.612 69.9164 168.383 69.5614C172.502 67.6654 172.487 60.8714 168.667 58.5904C167.977 58.1784 167.205 57.9334 166.412 57.8424Z",
    fill: "#1D1D1B"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M143.712 62.8079C142.03 63.0959 140.942 65.0649 141.488 66.6509C141.562 66.8669 141.855 66.7909 141.93 66.6259C142.646 65.0669 142.507 63.6069 144.735 63.6969C144.103 64.9739 144.111 67.2838 145.151 68.2138C145.374 68.4128 145.718 68.2769 145.681 67.9579C145.597 67.2459 145.236 66.6089 145.182 65.8719C145.127 65.1319 145.324 64.4839 145.463 63.7819C146.628 63.9999 147.694 64.6019 148.631 65.3079C148.761 65.4059 148.971 65.2378 148.88 65.0928C147.904 63.5468 145.533 62.4959 143.712 62.8079Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M170.433 45.6999C170.748 45.6059 171.069 45.5049 171.329 45.3039C171.589 45.1039 171.781 44.7819 171.736 44.4569C171.688 44.1069 171.378 43.8369 171.039 43.7369C170.7 43.6369 170.337 43.6749 169.988 43.7309C168.314 43.9979 166.7 44.6489 165.319 45.6319C165.111 45.7799 164.903 45.9409 164.771 46.1589C163.909 47.5839 166.135 46.7609 166.56 46.6739C167.865 46.4069 169.157 46.0819 170.433 45.6999Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M201.368 41.3438C201.804 41.2958 202.363 41.1198 202.364 40.6808C202.364 40.2528 201.826 40.0678 201.401 40.0198C199.591 39.8148 197.753 39.8678 195.958 40.1758C194.168 40.4828 193.469 42.2138 195.772 41.9598C197.636 41.7548 199.502 41.5498 201.368 41.3438Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M190.673 57.0198C190.118 54.9228 187.492 54.8888 185.84 55.5148C185.755 55.5468 185.799 55.6568 185.877 55.6578C187.379 55.6788 189.987 55.2938 190.169 57.4908C190.313 59.2328 188.646 60.2978 187.339 61.0458C187.073 61.1978 187.337 61.6698 187.607 61.5178C189.196 60.6228 191.236 59.1488 190.673 57.0198Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M186.609 70.071C184.167 70.362 181.881 70.391 179.619 69.249C177.537 68.198 176.295 66.61 174.877 64.836C174.788 64.724 174.633 64.827 174.67 64.954C176.059 69.772 182.266 72.301 186.811 70.85C187.254 70.709 187.056 70.018 186.609 70.071Z",
    fill: "#4E4E4E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_384_775",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 192,
    y: 46,
    width: 11,
    height: 7
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000163756431564719001640000008268599685151498657_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M202.885 50.3068C202.001 50.8718 200.995 51.3118 199.929 51.6088C198.44 52.0318 196.833 52.1798 195.29 52.0638C194.244 51.9848 193.215 51.7868 192.279 51.4598C192.611 50.5648 192.983 49.6448 193.463 48.8288C194.003 47.8878 194.698 47.0788 195.656 46.5908C197.027 45.8938 198.734 46.0438 200.064 46.8048C200.396 46.9898 200.712 47.2198 200.997 47.4638L201.009 47.4728C201.869 48.2258 202.501 49.2298 202.885 50.3068Z",
    fill: "white"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_384_775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M202.885 50.3068C202.001 50.8718 200.995 51.3118 199.929 51.6088C198.44 52.0318 196.833 52.1798 195.29 52.0638C194.244 51.9848 193.215 51.7868 192.279 51.4598C192.611 50.5648 192.983 49.6448 193.463 48.8288C194.003 47.8878 194.698 47.0788 195.656 46.5908C197.027 45.8938 198.734 46.0438 200.064 46.8048C200.396 46.9898 200.712 47.2198 200.997 47.4638L201.009 47.4728C201.869 48.2258 202.501 49.2298 202.885 50.3068Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_384_775",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 192,
    y: 46,
    width: 11,
    height: 7
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000163756431564719001640000008268599685151498657__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M202.885 50.3068C202.001 50.8718 200.995 51.3118 199.929 51.6088C198.44 52.0318 196.833 52.1798 195.29 52.0638C194.244 51.9848 193.215 51.7868 192.279 51.4598C192.611 50.5648 192.983 49.6448 193.463 48.8288C194.003 47.8878 194.698 47.0788 195.656 46.5908C197.027 45.8938 198.734 46.0438 200.064 46.8048C200.396 46.9898 200.712 47.2198 200.997 47.4638L201.009 47.4728C201.869 48.2258 202.501 49.2298 202.885 50.3068Z",
    fill: "white"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_384_775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M194.889 46.7499C193.367 47.5959 192.487 49.4619 192.802 51.1739C193.117 52.8859 194.603 54.3169 196.326 54.5669C198.049 54.8169 199.88 53.8669 200.668 52.3139C202.501 48.7029 198.429 44.7809 194.889 46.7499Z",
    fill: "#4E505B"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_384_775",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 49,
    width: 12,
    height: 7
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000156556761891787399680000014279924303141209506_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M176.351 53.4582C175.467 54.0232 174.461 54.4632 173.395 54.7602C171.906 55.1832 170.299 55.3312 168.756 55.2152C167.71 55.1362 166.681 54.9382 165.745 54.6112C166.077 53.7162 166.449 52.7962 166.929 51.9802C167.469 51.0392 168.164 50.2302 169.122 49.7422C170.493 49.0452 172.2 49.1952 173.53 49.9562C173.862 50.1412 174.178 50.3711 174.463 50.6151L174.475 50.6242C175.334 51.3762 175.966 52.3812 176.351 53.4582Z",
    fill: "white"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_384_775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M176.351 53.4582C175.467 54.0232 174.461 54.4632 173.395 54.7602C171.906 55.1832 170.299 55.3312 168.756 55.2152C167.71 55.1362 166.681 54.9382 165.745 54.6112C166.077 53.7162 166.449 52.7962 166.929 51.9802C167.469 51.0392 168.164 50.2302 169.122 49.7422C170.493 49.0452 172.2 49.1952 173.53 49.9562C173.862 50.1412 174.178 50.3711 174.463 50.6151L174.475 50.6242C175.334 51.3762 175.966 52.3812 176.351 53.4582Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_384_775",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 49,
    width: 12,
    height: 7
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000156556761891787399680000014279924303141209506__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M176.351 53.4582C175.467 54.0232 174.461 54.4632 173.395 54.7602C171.906 55.1832 170.299 55.3312 168.756 55.2152C167.71 55.1362 166.681 54.9382 165.745 54.6112C166.077 53.7162 166.449 52.7962 166.929 51.9802C167.469 51.0392 168.164 50.2302 169.122 49.7422C170.493 49.0452 172.2 49.1952 173.53 49.9562C173.862 50.1412 174.178 50.3711 174.463 50.6151L174.475 50.6242C175.334 51.3762 175.966 52.3812 176.351 53.4582Z",
    fill: "white"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_384_775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M168.326 49.5327C166.804 50.3787 165.924 52.2447 166.239 53.9567C166.554 55.6687 168.04 57.0997 169.763 57.3497C171.486 57.5997 173.317 56.6497 174.105 55.0967C175.938 51.4857 171.866 47.5647 168.326 49.5327Z",
    fill: "#4E505B"
  })))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    opacity: 0.8,
    d: "M167.89 21.1138C174.032 27.4788 183.541 30.3898 192.193 28.5538C194.434 28.0788 196.716 27.2398 198.222 25.5138C199.728 23.7878 200.183 20.9838 198.724 19.2168",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    opacity: 0.8,
    d: "M160.674 21.9268C150.864 27.6058 145.883 40.6147 146.021 50.0157",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    opacity: 0.8,
    d: "M171.318 19.0175C174.685 21.4695 178.619 23.3745 182.782 23.4905C186.946 23.6055 191.33 21.6315 193.252 17.9365",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    opacity: 0.8,
    d: "M172.635 14.7129C176.95 15.8139 181.793 14.5459 185.015 11.4729C186.139 10.4009 187.087 9.09588 187.494 7.59788C187.901 6.09988 187.705 4.39188 186.751 3.16688C185.798 1.94388 184.236 1.34689 182.704 1.11189C180.594 0.78789 178.237 1.1299 176.723 2.6349C175.209 4.1399 175.014 6.99489 176.715 8.28489",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    opacity: 0.8,
    d: "M158.444 17.8779C150.789 19.6079 144.387 25.9939 142.637 33.6449",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    opacity: 0.8,
    d: "M184.347 31.3569C188.235 32.5169 192.459 32.5259 196.353 31.3829C199.44 30.4769 202.458 28.7079 203.939 25.8519C205.419 22.9959 204.827 18.9509 202.069 17.2949",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    opacity: 0.8,
    d: "M185.71 25.7178C190.717 25.7498 195.555 22.2939 197.148 17.5479C198.741 12.8019 196.968 7.12684 192.956 4.13184",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    opacity: 0.8,
    d: "M152.39 24.7412C145.019 31.3112 141.185 41.6352 142.48 51.4242",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    opacity: 0.8,
    d: "M175.371 18.1862C178.899 19.9542 183.384 19.6252 186.617 17.3612C189.849 15.0972 191.692 10.9952 191.236 7.0752",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    opacity: 0.8,
    d: "M163.096 17.006C159.117 14.834 154.163 14.537 149.953 16.219C145.743 17.901 142.357 21.529 140.97 25.845",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby9Months);
export default __webpack_public_path__ + "static/media/baby-9-months.7683566da6dec958f8ae20ae2c7e0e07.svg";
export { ForwardRef as ReactComponent };